import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "../../../../../../../formLayout.scss";
import { Link, Box, Button, Modal } from "@mui/material";
import RKTextFieldDisable from "../../../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

function EditBranch() {
  const navigate = useNavigate();
  const [locationName, setLocationName] = React.useState("Chandigarh");
  const [taxid, setTaxId] = React.useState("KEP1245");
  const [streetName, setStreetName] = React.useState("GN Tower ");
  const [areaName, setAreaName] = React.useState("Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [state, setState] = React.useState("U.k.");
  const [city, setCity] = React.useState("Dehradun");
  const [zipCode, setZipCode] = React.useState("123654");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("userInformation");
  const [subSection, setSubSection] = React.useState<string>("basics");

  const country_data = [
    { label: "India", value: "India" },
    { label: "England", value: "England" },
    { label: "Australia", value: "Australia" },
    { label: "NewZealand", value: "NewZealand" },
  ];
  const state_data = [
    { label: "Haryana", value: "Haryana" },
    { label: "U.k.", value: "U.k." },
    { label: "U.P.", value: "U.P." },
    { label: "Punjab", value: "Punjab" },
  ];
  const city_data = [
    { label: "Dehradun", value: "Dehradun" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Gurugram", value: "Gurugram" },
    { label: "Noida", value: "Noida" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  // for scrolling
  const userInformation = useRef(null);
  const basics = useRef(null);
  const clientInfo = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Edit Chandigarh Branch</h3>
          </div>
        </Grid>
        <Grid xs={6}></Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection">
              <Link
                className={
                  sectionStatus === "userInformation"
                    ? "active sectionLink userInformation"
                    : "sectionLink userInformation"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(userInformation);
                  SetSectionStatus("userInformation");
                }}
              >
                <span> Branch Information</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basics"
                        ? "inner_link active basics"
                        : "inner_link  basics"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(basics);
                      setSubSection("basics");
                    }}
                  >
                    Basic Info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "clientInfo"
                        ? "inner_link active clientInfo"
                        : "inner_link clientInfo"
                    }
                    onClick={() => {
                      setSubSection("clientInfo");
                      handleClicks(subSection);
                      scrollToSection(clientInfo);
                    }}
                  >
                    Address
                  </Link>
                </li>
              </ul>
            </Grid>
            <Grid xs className="rightSection">
              <Box className="detailSection" ref={userInformation}>
                <div ref={basics}>
                  <div className="sectionTitle">
                    <h4>Branch Information</h4>
                  </div>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Basic Info</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Location Name"}
                        value={locationName}
                        attrName={setLocationName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Tax Id"}
                        value={taxid}
                        attrName={setTaxId}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div ref={clientInfo}>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Address</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Building/Street Name"}
                        value={streetName}
                        attrName={setStreetName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Area Name"}
                        value={areaName}
                        attrName={setAreaName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="Country"
                        value={country}
                        attrName={setCountry}
                        value_update={updateMasterState}
                        data={country_data}
                        warn_status={false}
                        error_message="Please select country"
                      />
                    </Grid>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="State"
                        value={state}
                        attrName={setState}
                        value_update={updateMasterState}
                        data={state_data}
                        warn_status={false}
                        error_message="Please select country"
                      />
                    </Grid>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdownDisable
                        class_name="inputField"
                        title="City"
                        value={city}
                        attrName={setCity}
                        value_update={updateMasterState}
                        data={city_data}
                        warn_status={false}
                        error_message="Please select country"
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextFieldDisable
                        class_name="inputField"
                        title={"Zip Code"}
                        value={zipCode}
                        attrName={setZipCode}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="outlined" className="borderBtn">
            Cancel
          </Button>

          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => {
              navigate(-1);
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default EditBranch;
